module.exports = __webpack_public_path__ + "img/FAQ-nav.1aeae768.png";